import React from 'react';
import './Error.css';

const Error = ({ error }) => {
    return (
        <div className="error-container">
            <h1 className="error-title">Oops, something went wrong!</h1>
            <p className="error-message">
                Yeah, we lost our db and it's gonna be tons of stress to create another db and manually create and input the data as we have no backup <strong><img className="error-gif" src="/future.jpeg" alt="future gif" /></strong> but we've learned to backup our db's now, thanks for checking my proj out btw! 😊
            </p>
        </div>
    );
};

export default Error;